import { api } from "../client";
import { AccountUserChangelog } from "../schema/AccountUserChangelog";
import { Config } from "../types";

type ApiRequestConfig = Config<AccountUserChangelog[]>;

export const getAccountUserChangelog = async (
  userId: number,
  config?: ApiRequestConfig
) => {
  return api.get<AccountUserChangelog[]>(
    `account_users/${userId}/account_user_histories`,
    config
  );
};
